import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
    Form, Input, FormFeedback, Label, Modal, ModalHeader, ModalBody,
} from "reactstrap";


//redux
import { useSelector, useDispatch } from "react-redux";
import withRouter from "components/_Common/withRouter";
import toastr from "toastr";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { addLanguage, editLanguage } from "store/actions";
import { withTranslation } from "react-i18next";


const AddEditModal = props => {
    const { modal, toggle, isEdit, itemData, fetchLanguageListData } = props
    const [languageData, setLanguageData] = useState();
    const { error, success, loading } = useSelector(state => ({
        loading: state.configurationsLanguages.loading,
        error: state.configurationsLanguages.error,
        success: state.configurationsLanguages.success,
    }));
    const dispatch = useDispatch();

    useEffect(() => {
        setLanguageData(itemData)
    }, [itemData])
    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            code: languageData?.code || '',
            label: languageData?.label || '',
            is_active: languageData?.is_active || 'Y'
        },
        validationSchema: Yup.object({

            code: Yup.string().required(`${props.t("Please Enter Your Language Code")}`),
            label: Yup.string().required(`${props.t("Please Enter Your Language Name")}`),
            is_active: Yup.string().required(`${props.t("Please Enter Language Status")}`),
        }),
        onSubmit: (values, { resetForm, setFieldValue }) => {
            if (isEdit) {
                dispatch(editLanguage(values, languageData?.id, (res) => {
                    if (res.status === 'success') {
                        toastr.success(res.message)
                        
                        resetForm({
                            code: '',
                            label: '',
                            is_active: 'Y'
                        });
                        fetchLanguageListData()
                        toggle()

                    } else {
                        toastr.error(res.message)
                        toggle()
                        

                    }
                }));
            } else {
                dispatch(addLanguage(values, props?.router?.navigate, (res) => {
                    if (res?.status === 'success') {
                        toastr.success(res.message)
                        
                        resetForm({
                            code: '',
                            label: '',
                            is_active: ''
                        });
                        fetchLanguageListData()
                        toggle()
                    } else {
                        toastr.error(res.message)
                        toggle()
                        

                    }
                }));
            }

        }
    });



    return (
        <React.Fragment>
            <Modal isOpen={modal} toggle={
                () => {
                    toggle()
                    
                }}>
                <ModalHeader tag="h4" toggle={
                    () => {
                        toggle()
                        
                    }}>
                    {!!isEdit ? props.t("Edit Language") : props.t("Add Language")}
                </ModalHeader>
                <ModalBody>
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}
                    >

                        <div className="mb-3 d-block">
                            <Label className="form-label m-0 pb-1">{props.t("Language Code")}:</Label>
                            <Input
                                name="code"
                                className="form-control"
                                placeholder={props.t("Enter Language Code")}
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.code || ""}
                                invalid={
                                    validation.touched.code && validation.errors.code ? true : false
                                }
                            />
                            {validation.touched.code && validation.errors.code ? (
                                <FormFeedback type="invalid">{validation.errors.code}</FormFeedback>
                            ) : null}
                        </div>

                        <div className="mb-3 d-block">
                            <Label className="form-label m-0 pb-1">{props.t("Language Name")}:</Label>
                            <Input
                                name="label"
                                className="form-control"
                                placeholder={props.t("Enter Language Name")}
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.label || ""}
                                invalid={
                                    validation.touched.label && validation.errors.label ? true : false
                                }
                            />
                            {validation.touched.label && validation.errors.label ? (
                                <FormFeedback type="invalid">{validation.errors.label}</FormFeedback>
                            ) : null}
                        </div>
                        <div className="mb-3 d-flex align-items-center gap-3">
                            <Label className="form-label m-0">{props.t("Status")}:</Label>
                            <div className="d-flex align-items-center gap-2">
                                <Input
                                    id="yes"
                                    name="is_active"
                                    type="radio"
                                    checked={validation.values.is_active == 'Y'}
                                    value="Y"
                                    onClick={(e) => {
                                        validation.setFieldValue('is_active', e.target.value);
                                    }}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                        validation.touched.is_active && validation.errors.is_active ? true : false
                                    }
                                />
                                <Label for="yes" className="form-label m-0">{props.t("Active")}</Label>
                                <Input
                                    id="no"
                                    name="is_active"
                                    checked={validation.values.is_active === 'N'}
                                    value="N"
                                    type="radio"
                                    onClick={(e) => {
                                        validation.setFieldValue('is_active', e.target.value);
                                    }}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                        validation.touched.is_active && validation.errors.is_active ? true : false
                                    }
                                />
                                <Label for="no" className="form-label m-0">{props.t("In-Active")}</Label>

                            </div>
                            {validation.touched.is_active && validation.errors.is_active ? (
                                <FormFeedback type="invalid">{validation.errors.is_active}</FormFeedback>
                            ) : null}
                        </div>

                        {
                            loading ?
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">

                                    <button
                                        type="button"
                                        className="btn btn-primary btn-block d-flex"
                                        disabled
                                    >
                                        <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                        {props.t("Submit")}
                                    </button>
                                </div>
                                :
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">
                                    <button
                                        className="btn btn-primary btn-block"
                                        type="submit"
                                    // disabled
                                    >
                                        {props.t("Submit")}
                                    </button>
                                </div>
                        }
                    </Form>
                </ModalBody>
            </Modal>

        </React.Fragment>
    );
};


AddEditModal.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};

export default withTranslation()(AddEditModal);

